import { useYogaContext } from '../../../core/context/YogaContext';
import Header from '../../../components/Header/Header';
import CompleteExperience from '../../../components/CompleteExperience/CompleteExperience';
import Banner from '../../../components/Banner/Banner';
import ArticleList from '../../../components/ArticleList/ArticleList';
import VideoSlider from '../../../components/VideoSlider/VideoSlider';
import SharedApps from '../../../components/SharedApps/SharedApps';
import {
  StyledPageContainer,
  StyledPageContent,
  StyledPageMainContent,
  StyledPageMainSidebar,
} from '../../../styles/config/pageStyle';

function Yoga() {
  const { banner, experience, article, videos, sharedApp } = useYogaContext();

  return (
    <>
      <Header title="explore" />
      <Banner data={banner} />

      <StyledPageContainer>
        <StyledPageContent>
          <StyledPageMainContent>
            <CompleteExperience data={experience} />
            <SharedApps data={sharedApp} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>

      <StyledPageContainer>
        <StyledPageContent reverse>
          <StyledPageMainSidebar>
            <VideoSlider data={videos} />
          </StyledPageMainSidebar>

          <StyledPageMainContent>
            <ArticleList articles={article} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Yoga;
